import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { createTheme, ThemeProvider } from "@mui/material/styles";

function CustomPagination({ page, total, limit, onPageChange }) {
  const totalPages = Math.ceil(total / limit);

  if (totalPages < 1) return null; // better UX

  const theme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#3b82f6",
      },
    },
    components: {
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            color: "#9ca3af",
            borderRadius: "10px",
            transition: "all 0.2s ease",
          },

          outlined: {
            borderColor: "rgba(255,255,255,0.08)",
          },

          page: {
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.06)",
              transform: "translateY(-1px)",
            },
          },

          selected: {
            backgroundColor: "rgba(59,130,246,0.18) !important",
            color: "#93c5fd",
            boxShadow: "0 0 12px rgba(59,130,246,0.25)",
          },
        },
      },
    },
  });

  return (
    <div className="mt-6 flex justify-center">
      <ThemeProvider theme={theme}>
        <Stack spacing={1}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => onPageChange(value)}
            variant="outlined"
            shape="rounded"
            showFirstButton
            showLastButton
            size="medium"
          />
        </Stack>
      </ThemeProvider>
    </div>
  );
}

export default CustomPagination;